export default {
  rateExceeded: 'Limite richiesta superato. L\'app riprenderà tra {ttl} secondi.',
};
